import { Injectable } from '@angular/core';
import { HttpService } from '@app/@core/services/http.service';
import { Observable } from 'rxjs';
export interface CheckPersonResponse {
  status: string
  data: boolean
}

@Injectable({
  providedIn: 'root'
})
export class ManageProfileService {

  constructor(private readonly httpservice: HttpService) {}

  getApplicantDetails(request: any): any{
    return this.httpservice.get('/registration/user/'+request);
  }

  checkSSN(request: any): Observable<any> {
    return this.httpservice.post('/registration/checkSsn', request);
  }

  verifyAndChangePrimaryEmail(recovery_email: string, newEmail: string, user_id: number, otp: string): Observable<any> {
    const request = { id:user_id, email:newEmail, recoveryEmail:recovery_email,  otp:otp };
    return this.httpservice.post('/registration/updatePrimaryEmail', request);
  }

  verifyAndChangeRecoveryEmail(email: string, newEmail: string, user_id: number, otp: string): Observable<any> {
    const request = { id:user_id, email:email, recoveryEmail:newEmail,  otp:otp };
    return this.httpservice.post('/registration/updatePrimaryEmail', request);
  }

  verifyAndChangePhoneNumber(newPhone: string, user_id: number, otp: string): Observable<any> {
    const request = { id:user_id, primaryPhone:newPhone, otp:otp };
    return this.httpservice.post('/registration/updatePhoneNumber', request);
  }

  verifyAndChangeAlternatePhoneNumber(newPhone: string, user_id: number, otp: string): Observable<any> {
    const request = { id:user_id, alternatePhone:newPhone, otp:otp };
    return this.httpservice.post('/registration/updateAlternatePhoneNumber', request);
  }

  updateUserDetails(user_id: number, userObj: any): Observable<any> {
    const request = {id: user_id, userData: userObj};
    return this.httpservice.post('/registration/updateUser', request);
  }

  checkEmailExists(email: string): Observable<any> {
    return this.httpservice.post('/registration/checkEmail', { email });
  }

  checkPhoneExists(phone: string): Observable<any> {
    return this.httpservice.post('/registration/checkPhone', { phone });
  }
  
  updateRecoveryEmailNotification(request: any): Observable<any> {
    return this.httpservice.post('/registration/updateRecoveryEmailNotification', request);
  }
  
  updatePhoneNumberNotification(email: string, phone: string, person_id: number,): Observable<any> {
    const request = {email, phone, person_id };
    return this.httpservice.post('/registration/updatePhoneNumberNotification', request);
  }
  
  updateProfileNotification(
    oldEmail: string,
    newValue: string,
    type:string,
    person_id: number
  ): Observable<any> {
    const request = { oldEmail, newValue, type, person_id };
    return this.httpservice.post('/registration/phoneUpdatedNotification', request);
  }


  sendChangeContactOTP(type: string, email: string, phone: string, person_id: number): Observable<any> {
    const request = { type, email, phone, person_id };
    return this.httpservice.post('/registration/verifyEmail', request);
  }

  resendChangeContactOTP(type: string, email: string, phone: string, person_id: number): Observable<any> {
    const request = { type, email, phone, person_id };
    return this.httpservice.post('/registration/resendEmailOtp', request);
  }

  sendMailUpdateNotification(type: string, oldEmail: string, newEmail: string, person_id: number): Observable<any> {
    const request = { type, oldEmail, newEmail, person_id };
    return this.httpservice.post('/registration/emailUpdateNotification', request);
  }


  updatePhone(request: any): Observable<any>{
      return this.httpservice.post('/registration/updatePhone', request);
    }

  updateNewPhoneNumberNotification(request: any): Observable<any> {
    return this.httpservice.post('/registration/updateNewPhoneNumberNotification', request);
  }

  getBusinessRuleByKey(category: string, strRuleKey: string): Observable<any> {
    return this.httpservice.get(`/business-rules/fetch-buisness-rules-by-key?category=${category}&strRuleKey=${strRuleKey}`);
  }
  checkPossibleDuplicate(request: any): Observable<any> {
    return this.httpservice.post('/registration/possibleDuplicateCheck', request);
  }
  getLicenseProvisionByPersonId(personId: any): Observable<any> {
    return this.httpservice.get(`/search/getLicenseProvision/${personId}`);
  }
  getLicenseRequirementByPersonId(personId: any): Observable<any> {
    return this.httpservice.get(`/search/getPersonLicenseRequirement/${personId}`);
  }
  addLicenseEndorsement(payload: any): Observable<any> {
    return this.httpservice.post(`/search/educator-add-license-endorsement`, payload);
  }
  updateLicenseEndorsement(payload: any): Observable<any> {
    return this.httpservice.put(`/search/educator-update-license-endorsement`, payload);
  }
  deleteLicenseEndorsement(payload: any): Observable<any> {
    return this.httpservice.patch(`/search/educator-delete-license-endorsement`, payload);
  }
  saveLicenseRequirement(payload: any): Observable<any> {
    return this.httpservice.post(`/search/save-person-license-requirements`, payload);
  }
  updateLicenseRequirement(payload: any): Observable<any> {
    return this.httpservice.patch(`/search/update-person-license-requirements`, payload);
  }
  deleteLicenseRequirement(payload: any): Observable<any> {
    return this.httpservice.post(`/search/delete-person-license-requirements`, payload);
  }
  saveLicenseProvisions(payload: any): Observable<any> {
    return this.httpservice.post(`/search/save-license-provisions`,payload);
  }

  deleteLicenseProvisions(Payload: any): Observable<any> {
    return this.httpservice.post(`/search/delete-license-provisions`,Payload);
  }

  updateLicenseProvisions(Payload: any): Observable<any> {
    return this.httpservice.patch(`/search/update-license-provisions`,Payload);
  }


  getLicenseKindEndorsementsByPersonId(personId: any): Observable<any> {
    return this.httpservice.get(`/search/getLicenseKindEndorsements/${personId}`);
  }
  
  saveLicenseKindEndorsements(request: any): Observable<any> {
    return this.httpservice.post('/search/save-license-kind-endorsement', request);
  }

  postLicenseKindEndorsements(request: any): Observable<any> {
    return this.httpservice.patch('/search/update-license-kind-endorsement', request);
  }

  deleteLicenseKindEndorsements(request: any): Observable<any> {
    return this.httpservice.post('/search/delete-license-kind-endorsement', request);
  }

  sendLicenseEmail(personId: any, emailID: string): Observable<any> {
    return this.httpservice.get(`/search/send_license_email/${personId}/${emailID}`);
  }
  syncEmailToAzure(payload: { currentEmail: string; newEmail: string }): Observable<any> {
    return this.httpservice.post('/registration/syncEmailToAzure', payload);
  }
  
}
